import { render, staticRenderFns } from "./TableCalculationExample.vue?vue&type=template&id=181e523c&"
import script from "./TableCalculationExample.vue?vue&type=script&lang=js&"
export * from "./TableCalculationExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports